import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { Package } from 'src/models';

const companyPackagesApiPath = (companyId: string) =>
  `/companies/${companyId}/packages`;

export const getPackages = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<Package[] & ApiError>> => {
  return instance
    .get<Package[]>(companyPackagesApiPath(companyId))
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

const activateCompanyPackageApiPath = (companyId: string, packageId: string) =>
  `${companyPackagesApiPath(companyId)}/${packageId}/activate`;

export const activatePackageAPI = async ({
  companyId,
  packageId,
}: {
  companyId: string;
  packageId: string;
}): Promise<AxiosResponse<Package & ApiError>> => {
  return instance
    .post<Package>(activateCompanyPackageApiPath(companyId, packageId))
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

const deactivateCompanyPackageApiPath = (
  companyId: string,
  packageId: string,
) => `${companyPackagesApiPath(companyId)}/${packageId}/deactivate`;

export const deactivatePackageAPI = async ({
  companyId,
  packageId,
}: {
  companyId: string;
  packageId: string;
}): Promise<AxiosResponse<Package & ApiError>> => {
  return instance
    .post<Package>(deactivateCompanyPackageApiPath(companyId, packageId))
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
